import {Modal} from "@mui/material";
import {Save} from "Components/Buttons/Save";
import {useUserBankCardsQuery} from "Hooks/Queries/User/useUserBankCardsQuery";
import {removeMember} from "Reducers/FamilyMembers";
import {API_REQUEST} from "Request/API";
import {useAppDispatch, useAppSelector} from "Store/store";
import {memo, useRef} from "react";
import {ReactSVG} from "react-svg";
import {toast} from "react-toastify";

export const DeleteCard = memo(function DeleteCard({
                                                     open,
                                                     close,
                                                     text,
                                                     cardId,
                                                     cardSourceId
                                                   }: {
  cardId: number;
  open: boolean;
  close?: () => void;
  text: string;
  cardSourceId: string,
}) {
  const containerRef = useRef(null);
  const {isRefetchBankCard} = useUserBankCardsQuery();

  return (
      <>
        <div className="absolute" ref={containerRef}></div>
        <Modal
            open={open}
            onClose={close}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            container={containerRef.current}
            className="flex items-center justify-center outline-0"
        >
          <div
              className="w-[398px] py-[20px] px-[30px] outline-0 flex flex-col items-center gap-6 rounded-[12px] bg-[#fff]">
            <div className="flex items-center justify-center rounded-[50%] w-[60px] h-[60px] bg-raspberry-10">
              <ReactSVG src="/images/icons/trash.svg"/>
            </div>
            <h2 className="text-center text-[14px] font-demi text-blackPrimary-60">
              {text}
            </h2>
            <div className="flex gap-4">
              <Save
                  onClick={() => {
                    close && close();
                  }}
                  variant="gray"
                  label="არა,არ მსურს"
              />
              <Save
                  onClick={() => {
                    if (cardId) {
                      API_REQUEST(
                          "DELETE",
                          `medical/bank/cards`,
                          {
                            sourceId: cardSourceId,
                            cardId: cardId,
                          },
                          undefined,
                          "fullresponse"
                      )
                          .then((e) => {
                            close && close();
                            isRefetchBankCard();
                            toast("ბარათი წაიშალა", {
                              type: "success",
                              position: "bottom-right",
                              autoClose: 5000,
                              hideProgressBar: true,
                              closeOnClick: true,
                              draggable: true,
                              theme: "success",
                            });
                          })
                          .catch((e) => {
                                console.log("eee", e.response.data.errorCode);

                                if (e.response.data.errorCode === 10000001) {
                                  toast("თქვენი ბარათი მიბმულია VITA ბარათის აქტიურ გამოწერაზე. ბარათის წაშლისთვის გთხოვთ, შეცვალოთ აქტიური გამოწერის გადახდის მეთოდი.", {
                                    type: "error",
                                    position: "bottom-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    draggable: true,
                                    theme: "light",
                                  })
                                } else {
                                  toast("მოხდა შეცდომა", {
                                    type: "error",
                                    position: "bottom-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    draggable: true,
                                    theme: "light",
                                  })
                                }
                              }
                          );
                    } else {
                      close && close();
                    }
                  }}
                  variant="green"
                  label="დიახ, მსურს"
              />
            </div>
          </div>
        </Modal>
      </>
  );
});
